import { combineReducers } from "redux";

import { generateCrudRedux, ICRUDReduxState } from "../../../../core/redux";
import { IProduct, IProductForm } from "../../data/entities";
import { ProductRepoImpl } from "../../data/repo";

export const productRedux = generateCrudRedux<IProduct, IProductForm>({
  actionTypeName: "Product",
  repository: ProductRepoImpl,
});

export interface IProductReduxState extends ICRUDReduxState<IProduct> {}

export const ProductReducers = combineReducers<IProductReduxState>({
  ...productRedux.reducer,
});
